import React, { useEffect, useState } from 'react'
import JointlyOwnedVehicleInformationView from './components/JointlyOwnedVehicleInformationView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'
import { useSelector } from 'react-redux';

const JointlyOwnedVehicleInformation = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  const addressTypeChange = useSelector((state) => state.app.addressTypeChange);
  useEffect(() => {
    try {
      addToGoogleDataLayer('jointly-owned-vehicle-info', 'Change of Address', i18n.language, addressTypeChange)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [i18n.language, addressTypeChange])

  return isError ? <Error /> : <JointlyOwnedVehicleInformationView setIsError={setIsError} />
}

export default withTranslation('common')(JointlyOwnedVehicleInformation)
